module.exports = __webpack_public_path__ + "static/media/folder_color-4.da57df44.svg";